import * as yup from 'yup'
import { ImportBranchDto } from './importBranchDto'

export class PortOfEntryDto {
  portOfEntryGuid?: string = undefined
  cityState?: string = ''
  portCode?: string = undefined
  isActive?: boolean = undefined
  importBranches?: ImportBranchDto[] = []
}

export const portOfEntryValidationSchema = yup.object({
  id: yup.string().nullable(),
  cityState: yup
    .string()
    .max(2000, 'City, and State cannot be more than 2000 characters.')
    .required('City, and State are required.'),
  portCode: yup
    .string()
    .matches(/^\d{4}$/, 'Port Code must be 4 digits.')
    .required('Port Code is required.'),
  isActive: yup.boolean()
})
